export enum PrimaryIncomeMessage {
  Weekly = 'You have selected weekly, is this correct?',
  Monthly = 'You have selected monthly, is this correct?',
}
